import React, { Component } from "react";
import MainLayout from "../../../components/Layout/MainLayout";
import MapQuyHoach from "../MapQuyHoach";
import Map from "./Map";
import { Button, Col, Row, Select, Table, Input, Tabs } from "antd";
import "../quy-hoach-kien-truc.scss";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import SearchResult5000 from "./SearchResult5000";
import { connect } from "react-redux";
import TableRanhGioi from "./TableRanhGioi";
import StaticClass from "../../../utils/staticClass";

class QuyHoach5000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listPhanKhu: [],

      listQuyHoach: [],

      selectedPhanKhu: undefined,
      selectedQuyHoach: undefined,
      SoQD: undefined,
      NamQH: undefined,

      dataTable: [],
      pagination: { pageSize: 10, total: 1, current: 1 },
      isLoading: true,
      currentIndex: null,

      dataSearch: undefined,

      isShowSearchResult: false,
      resetButton: false,
      activeKey: "DuAn",
      query: "",
    };

    this.columns = [
      {
        title: "STT",
        dataIndex: "key",
      },
      {
        title: <div style={{ textAlign: "center" }}>Tên phân khu</div>,
        dataIndex: "TenPhanKhu",
      },

      {
        title: <div style={{ textAlign: "center" }}>Năm quy hoạch</div>,
        dataIndex: "NamQH",
      },

      {
        title: <div style={{ textAlign: "center" }}>Diện tích (ha)</div>,
        dataIndex: "DienTich",
        render: (cell, row, index) => {
          let DienTich = row.DienTich;
          return StaticClass.formatPrice(DienTich);
          // if (DienTich && !Number.isInteger(DienTich))
          //   DienTich = DienTich.toFixed(3);
          // return <div>{DienTich}</div>;
        },
      },
    ];

    this.map = React.createRef();
    this.tableRanhGioi = React.createRef();
    this.listPhanKhu = [];
  }

  componentDidMount() {
    this.getDataDuAn();
    this.getDataOQuyHoach();
    this.onSearchClick();
  }

  async getDataDuAn() {
    let res = await AxiosGetSecretApi("/api/qh-phan-khu/cbTenDuAn");
    if (res && Array.isArray(res)) {
      this.setState({ listPhanKhu: res, listPhanKhuConst: res });
      this.listPhanKhu = res;
    }
  }

  async getDataOQuyHoach() {
    let res = await AxiosGetSecretApi(`/api/qh-phan-khu/cbOquyhoach`);
    this.setState({
      listQuyHoach: res && Array.isArray(res) ? res : [],
    });
    this.listQuyHoach = res && Array.isArray(res) ? res : [];
  }

  async onChangePhanKhu(value, option) {
    let listQuyHoach = [];
    if (option.id) {
      let res = await AxiosGetSecretApi(
        `/api/qh-phan-khu/cbOquyhoach?OBJECTID=${option.id}`
      );
      if (res && Array.isArray(res)) {
        listQuyHoach = res;
        let selectedQuyHoach = res.filter(
          (e) => e.OQuyHoach === this.state.selectedQuyHoach
        );
        if (selectedQuyHoach.length === 0) {
          this.setState({
            selectedQuyHoach: undefined,
          });
        }
      }
    }

    this.setState({
      selectedPhanKhu: value,
      selectedPhanKhuID: option.id,
      listQuyHoach: listQuyHoach,
    });
  }

  onResetButton() {
    this.map.current.handleCloseClick();
    this.onSearchClick("TimMoi");
    this.setState({
      selectedPhanKhu: undefined,
      selectedPhanKhuID: undefined,
      selectedQuyHoach: undefined,
      SoQD: undefined,
      NamQH: undefined,

      listQuyHoach: this.listQuyHoach,
      currentIndex: null,
      isShowSearchResult: undefined,
      resetButton: !this.state.resetButton,
      dataFile: [],
    });

    if (this.tableRanhGioi.current) {
      this.tableRanhGioi.current.handleReset();
    }
  }

  // table
  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleTableChange = async (pagination) => {
    await this.SetStateAsync({ pagination });
    this.onSearchClick('pagination');
  };

  onSearchClick = async (e) => {
    this.setState({
      isLoading: true,
    });

    if (e === "TimKiem") {
      this.SetStateAsync({
        pagination: { pageSize: 10, total: 1, current: 1 },
        currentIndex: null,
      });
    }
    let query = ''
    let url = "";
    if (e === "TimMoi") {
      url = `/api/qh-phan-khu/search?curPage=1&pageSize=10`;
      this.setState({query})
    } else {
      url = `/api/qh-phan-khu/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;

      if (this.state.selectedPhanKhu) {
        let TenDuAn = encodeURIComponent(this.state.selectedPhanKhu);
        query = query + `TenDuAn=${TenDuAn}&`;
        url = url + `TenDuAn=${TenDuAn}&`;
      }

      if (this.state.SoQD) {
        query = query + `QuyetDinhPhapLy=${this.state.SoQD}&`;
        url = url + `QuyetDinhPhapLy=${this.state.SoQD}&`;
      }

      if (this.state.NamQH) {
        query = query + `NamQH=${this.state.NamQH}&`;
        url = url + `NamQH=${this.state.NamQH}&`;
      }
    }

    if (e === "pagination") {
      url = `/api/qh-phan-khu/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
      query = this.state.query;
      url = url + query;
    }

    if (e === "TimKiem") {
      this.setState({query: query})
    }
    
    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          key:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      this.setState({
        dataTable: dataTable,
        pagination: res.dataPaginate,
        isLoading: false,
      });
    } else {
      this.setState({
        dataTable: dataTable,
        pagination: this.state.pagination,
        isLoading: false,
      });
    }
  };

  onShowSearchResult = () => {
    this.setState({
      isShowSearchResult: "search",
    });
  };

  onCloseSearchResult = () => {
    this.setState({
      isShowSearchResult: "button",
    });
  };

  async getFile(id) {
    let res = await AxiosGetSecretApi(`/api/qh-phan-khu/getAllAsset?ID=${id}`);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.setState({
        dataFile: res,
      });
    } else {
      this.setState({
        dataFile: [],
      });
    }
  }

  onSearchByObjectId = async (id) => {
    this.setState({
      isLoading: true,
    });

    let url = `/api/qh-phan-khu/search?curPage=1&pageSize=10&OBJECTID=${id}`;

    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          stt:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      if (res.dataResult.length !== 0) {
        this.getGeoData(res.dataResult[0].OBJECTID);
        this.getFile(res.dataResult[0].OBJECTID);
        this.setState({
          currentIndex: 0,
          dataSearch: res.dataResult[0],
          isShowSearchResult: "search",
          pagination: res.dataPaginate,
        });
      } else {
        this.setState({
          pagination: res.dataPaginate,
        });
      }
    }
    this.setState({
      dataTable: dataTable,
      pagination: this.state.pagination,
      isLoading: false,
    });
  };

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/8/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.map.current.drawRing(res.features[0].geometry.rings);
    // console.log(res.features[0].geometry.rings)
  }

  handleSearch() {
    this.setState({
      activeKey: this.state.selectedQuyHoach ? "OQuyHoach" : "DuAn",
    });
    this.onSearchClick();
    if (this.tableRanhGioi.current) {
      this.tableRanhGioi.current.handleSearch();
    }
  }

  render() {
    return (
      <MainLayout {...this.props} title={"Quy hoạch phân khu 1/5000"}>
        <div className="quy-hoach-main">
          <div style={{ padding: "10px" }}>
            <div className="quy-hoach">
              <div className="quy-hoach-header">
                Danh sách Dự án Quy hoạch phân khu 1/5000
              </div>

              <div className="quy-hoach-body">
                <div className="search-input">
                  <Row gutter={[20, 0]} style={{ marginBottom: "15px" }}>
                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Tên phân khu</div>
                        </div>

                        <div className="gr-body">
                          <Select
                            className="select"
                            showSearch
                            value={this.state.selectedPhanKhu}
                            onChange={(value, option) =>
                              this.onChangePhanKhu(value, option)
                            }
                          >
                            {this.state.listPhanKhu.map((e, i) => (
                              <Select.Option
                                value={e.TenPhanKhu}
                                key={i}
                                id={e.OBJECTID}
                              >
                                {e.TenPhanKhu}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Số quyết định</div>
                        </div>

                        <div className="gr-body">
                          <Input
                            className="input"
                            value={this.state.SoQD}
                            onChange={(e) => {
                              this.setState({ SoQD: e.target.value });
                            }}
                          ></Input>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={[20, 0]} style={{ marginBottom: "15px" }}>
                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Năm quy hoạch</div>
                        </div>

                        <div className="gr-body">
                          <Input
                            className="input"
                            value={this.state.NamQH}
                            onChange={(e) => {
                              this.setState({ NamQH: e.target.value });
                            }}
                          ></Input>
                        </div>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Ô quy hoạch</div>
                        </div>

                        <div className="gr-body">
                          <Select
                            className="select"
                            showSearch
                            value={this.state.selectedQuyHoach}
                            onChange={(value) =>
                              this.setState({ selectedQuyHoach: value })
                            }
                            notFoundContent={
                              this.state.selectedPhanKhu
                                ? "Không có dứ liệu"
                                : "Vui lòng chọn phân khu"
                            }
                          >
                            {this.state.listQuyHoach.map((e, i) => (
                              <Select.Option value={e.OQuyHoach} key={i}>
                                {e.OQuyHoach}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div style={{ display: "flex" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        this.onResetButton();
                      }}
                      className="search-button"
                    >
                      Tìm mới
                    </Button>

                    <Button
                      type="primary"
                      // onClick={this.onSearchClick}
                      onClick={() => this.handleSearch("TimKiem")}
                      className="search-button"
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </div>
              </div>

              <div className="quy-hoach-footer">
                <Tabs
                  activeKey={this.state.activeKey}
                  onChange={(e) => {
                    this.setState({ activeKey: e });
                  }}
                >
                  <Tabs.TabPane
                    key="DuAn"
                    tab={
                      <div style={{ width: "236px", textAlign: "center" }}>
                        Quản lý ranh giới phân khu
                      </div>
                    }
                  >
                    <div
                      style={{
                        maxHeight: "calc(100vh - 432px)",
                        overflow: "auto",
                      }}
                    >
                      <Table
                        columns={this.columns}
                        dataSource={this.state.dataTable}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        bordered
                        pagination={{
                          ...this.state.pagination,
                          showSizeChanger: false,
                        }}
                        onChange={this.handleTableChange}
                        size="small"
                        loading={this.state.isLoading}
                        rowKey={(record) => record.OBJECTID}
                        rowClassName={(record, index) =>
                          index +
                            (this.state.pagination.current - 1) *
                              this.state.pagination.pageSize ===
                          this.state.currentIndex
                            ? "highlight"
                            : "not-highlight"
                        }
                        onRow={(record, rowIndex) => {
                          return {
                            onClick: async (event) => {
                              this.getGeoData(record.OBJECTID);
                              this.getFile(record.OBJECTID);
                              this.setState({
                                currentIndex:
                                  rowIndex +
                                  (this.state.pagination.current - 1) *
                                    this.state.pagination.pageSize,
                                dataSearch: record,

                                isShowSearchResult: "search",
                              });
                            }, // click row
                          };
                        }}
                      />
                    </div>
                  </Tabs.TabPane>

                  <Tabs.TabPane
                    key="OQuyHoach"
                    tab={
                      <div style={{ width: "236px", textAlign: "center" }}>
                        Quản lý thửa đất phân khu
                      </div>
                    }
                  >
                    <div
                      style={{
                        maxHeight: "calc(100vh - 432px)",
                        overflow: "auto",
                      }}
                    >
                      <TableRanhGioi
                        ref={this.tableRanhGioi}
                        selectedPhanKhu={this.state.selectedPhanKhuID}
                        selectedQuyHoach={this.state.selectedQuyHoach}
                        SoQD={this.state.SoQD}
                        NamQH={this.state.NamQH}
                        map={this.map}
                      />
                    </div>
                  </Tabs.TabPane>
                </Tabs>
              </div>

              {this.state.isShowSearchResult === "search" && (
                <SearchResult5000
                  data={this.state.dataSearch}
                  file={this.state.dataFile}
                  close={this.onCloseSearchResult}
                ></SearchResult5000>
              )}

              {/* {this.state.isShowSearchResult === "button" && (
                <Button
                  className="close-popup-result"
                  type="primary"
                  onClick={this.onShowSearchResult}
                >
                  <i className="fas fa-search"></i>
                </Button>
              )} */}
            </div>
          </div>

          <div className="quy-hoach-map">
            <Map
              type="QHPK"
              ref={this.map}
              resetButton={this.state.resetButton}
              isShowMenu={this.props.isShowMenu}
              searchDataTable={this.onSearchByObjectId}
              listPhanKhu={this.state.listPhanKhuConst}
            ></Map>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isShowMenu: state.menu.isShowMenu,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuyHoach5000);
